import {baseApi} from './baseApi';

export const injectedParcelApi = baseApi.injectEndpoints({
    addTagTypes: ['Parcel'],
    endpoints: (builder) => ({
        getParcel: builder.query({
            query: (args) => {
                const {projectId, flurstueckId, personId, commonData, mapping, utilisation} = args;

                let url = `getParcel?project_id=${projectId}&common_data=${commonData}`;

                if (flurstueckId) {
                    url += `&flurstueck_id=${flurstueckId}`;
                }

                if (utilisation) {
                    url += `&utilisation=true`;
                }

                if (mapping) {
                    let key = Object.keys(mapping)[0];
                    let value = mapping[key];
                    url += `&${key}=${value}`;
                }

                return {url: url};
            },
            providesTags: ['Parcel']
        }),
        getParcelUseTypes: builder.query({
            query: (args) => {
                let url = `getParcelUseTypes`;

                return {url: url};
            },
            providesTags: ['Parcel']
        }),
        getValuationTypes: builder.query({
            query: (args) => {
                let url = `getValuationTypes`;

                return {url: url};
            },
            providesTags: ['Parcel']
        }),
        getRegisterUpdateTypes: builder.query({
            query: (args) => {
                let url = `getRegisterUpdateTypes`;

                return {url: url};
            },
            providesTags: ['Parcel']
        }),
        getGemarkungCodes: builder.query({
            query: (args) => {
                let url = `getGemarkungCodes`;

                return {url: url};
            },
            providesTags: ['Parcel']
        }),
        createParcel: builder.mutation({
            query: (parcel) => ({
                url: 'createParcel',
                method: 'POST',
                body: parcel,
            }),
            invalidatesTags: ['Parcel', 'Person', 'LandRegister']
        }),
        createParcelPersonMap: builder.mutation({
            query: (parcel) => ({
                url: 'createParcelPersonMap',
                method: 'POST',
                body: parcel,
            }),
            invalidatesTags: ['Parcel', 'Person', 'LandRegister']
        }),
        updateParcel: builder.mutation({
            query: (parcel) => ({
                url: 'updateParcel',
                method: 'PUT',
                body: parcel,
            }),
            invalidatesTags: ['Parcel', 'Person', 'LandRegister']
        }),
        exportDataToProject: builder.mutation({
            query: (parcel) => ({
                url: 'exportDataToProject',
                method: 'POST',
                body: parcel,
            }),
            invalidatesTags: ['Parcel', 'Person']
        }),
        deleteParcel: builder.mutation({
            query: (parcel) => ({
                url: 'deleteParcel',
                method: 'DELETE',
                body: parcel,
            }),
            invalidatesTags: ['Parcel', 'Person', 'LandRegister']
        }),
    }),
});

export const {
    useGetParcelQuery,
    useLazyGetParcelQuery,
    useGetParcelUseTypesQuery,
    useGetValuationTypesQuery,
    useGetRegisterUpdateTypesQuery,
    useGetGemarkungCodesQuery,
    useCreateParcelMutation,
    useCreateParcelPersonMapMutation,
    useUpdateParcelMutation,
    useExportDataToProjectMutation,
    useDeleteParcelMutation,
} = injectedParcelApi;
